export const calcularQtdDependentesConjuge = (dependentes) => {
    const dependentesConjuge = dependentes.filter(
        (dependente) => dependente['GrauParentesco.Grau'].trim() === '10'
    );
    return dependentesConjuge;
};

export const validatorAte18anos = (valoresForm) => {
    const arrayDeValidacoes = [
        verificarNaoConjuge(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        idadeMenorIgual18(valoresForm.Idade),
        verificarTipoAdicionalAte18Anos(valoresForm.Categoria),
    ];
    return arrayDeValidacoes.every((validacao) => validacao === true);
};

export const validator19Ate64Anos = (valoresForm) => {
    const arrayDeValidacoes = [
        verificarNaoConjuge(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        idadeMenor19Ate64(valoresForm.Idade),
        verificarTipoAdicional19Ate64anos(valoresForm.Categoria),
    ];
    return arrayDeValidacoes.every((validacao) => validacao === true);
};

export const validator65anos = (valoresForm) => {
    const arrayDeValidacoes = [
        verificarNaoConjuge(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        idadeMenorMaiorIgual65anos(valoresForm.Idade),
        verificarTipoAdicional65anos(valoresForm.Categoria),
    ];
    return arrayDeValidacoes.every((validacao) => validacao === true);
};

const verificarNaoConjuge = (parentesco) => parentesco.trim() !== '10';
const verificarIdadePreenchida = (idade) => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = (categoria) => categoria !== '';
const idadeMenorIgual18 = (idade) => idade <= 18;
const idadeMenor19Ate64 = (idade) => idade > 18 && idade <= 64;
const idadeMenorMaiorIgual65anos = (idade) => idade >= 65;
const verificarTipoAdicionalAte18Anos = (categoria) => categoria.trim() !== 'ZUT18';
const verificarTipoAdicional19Ate64anos = (categoria) => categoria.trim() !== 'ZUT64';
const verificarTipoAdicional65anos = (categoria) => categoria.trim() !== 'ZUT65';
